import { useBoolean } from "ahooks"
import { Flex } from "antd-mobile"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Route, Switch, withRouter } from "react-router-dom"
import { saveUserInfo } from "../../actions/user"
import Dynamic from "../../components/Dynamic"
import Loading from "../../components/Loading"
import cookie from "../../utils/cookie"
import { wxInvoke } from "../../utils/libs/qywx"
import {
  getCustomerIdByUserId,
  getCustomerInfoByCustomerId,
} from "../../utils/servers"
import { isNotEmptyArray, updateDocTitle } from "../../utils/utils"
import { ROUTER_CONFIG } from "./common"
import styles from "./index.module.less"

interface Props {
  [key: string]: any
}
const Home: React.FC<Props> = ({ user, saveUser, ...props }) => {
  const {
    history,
    location: { pathname },
  } = props
  const { replace } = history
  const [tips, setTips] = useState("")
  // const [isNotCustomer, { setTrue: entryNotCustomer }] = useBoolean(false);
  const [isCustomer, { setTrue: entryCustomer }] = useBoolean(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [groupID, setGroupID] = useState<string | number>()

  // 判断入口
  useEffect(() => {
    if (!pathname || pathname?.includes("/customer") || pathname === "/") {
      entryCustomer()
    } else {
      setLoading(false)
    }
  }, [entryCustomer])

  useEffect(() => {
    const res: any =
      ROUTER_CONFIG.filter((item: any) => {
        return pathname.includes(item.path)
      }) || []
    if (isNotEmptyArray(res)) {
      updateDocTitle(res[0]?.title)
    }
  }, [])

  useEffect(() => {
    const getUserID = () => {
      wxInvoke(
        "getCurExternalContact",
        {},
        {
          cb: (id: any) => {
            saveUser({ wxUserId: id })
            // 如果是商品详情访问 则直接跳转到商品详情
          },
          errorCallback: () => {
            console.log("获取微信ID失败")
            // Toast.info("获取微信ID失败");
            // saveUser({ wxUserId: "wmfFcnBwAALdebfUtA9MD6UFScnYrWQQ" });
            setLoading(false)
          },
          errorTip: false,
        },
      )
    }
    //获取群ID
    const getGroupID = () => {
      wxInvoke(
        "getCurExternalChat",
        {},
        {
          cb: (id: any) => {
            console.log("获取客户群ID为：", id)
            setGroupID(id)
          },
          errorCallback: () => {
            console.log("获取客户群ID失败")
            setLoading(false)
          },
          errorTip: false,
        },
      )
    }
    if (isCustomer) {
      getUserID()
      getGroupID()
    }
  }, [saveUser, isCustomer])

  // 查询客户ID - 微信userId
  useEffect(() => {
    if (user.wxUserId && isCustomer) {
      getCustomerIdByUserId(user.wxUserId)
        .then((res) => {
          const curentEmployeeCode = cookie.getCookie("employeeWorkCode")
          if (res?.data) {
            // data 客户的实体对象  employeeWorkCode不相等则已被绑定给其他顾问 转向客户微信详情
            if (res.data.employeeWorkCode !== curentEmployeeCode) {
              setTips("您无法查看该客户详情，已被他人绑定!")
            } else {
              saveUser({ customerId: res.data.id })
            }
          } else {
            //没有数据或其他错误跳转到绑定页面
            replace(`/customer/bind/${user.wxUserId}`)
          }
        })
        .catch((e) => {
          setLoading(false)
          console.warn("server getCustomerIdByUserId error", e)
        })
    } else {
      setLoading(false)
    }
  }, [user.wxUserId, saveUser, replace, isCustomer])

  // 查询客户详情 - customerId
  useEffect(() => {
    if (user.customerId) {
      getCustomerInfoByCustomerId(user.customerId)
        .then((res) => {
          saveUser({ customerDetails: res.data })
          replace(`/customer/details/${user.customerId}`)
        })
        .catch((e) => {
          console.warn("getCustomerInfoByCustomerId catch:", e)
        })
    }
  }, [user.customerId, saveUser, replace])

  useEffect(() => {
    if (groupID) {
      replace(`/group/detail/${groupID}`)
    }
  }, [groupID])

  return (
    <div className={styles.container} id="containerContent">
      <Loading isloading={loading}>
        {tips ? (
          <Flex justify="center" className={styles.content}>
            {tips}
          </Flex>
        ) : (
          <Switch>
            <Route path="/customer">
              <Route path="/customer/bind/:wxUserId">
                <Dynamic
                  loader={() => {
                    return import("../BindCustomer")
                  }}
                />
              </Route>
              <Route path="/customer/details/:customerId">
                <Dynamic
                  loader={() => {
                    return import("../CustomerDetail")
                  }}
                />
              </Route>
              <Route path="/customer/content/:customerId">
                <Dynamic
                  loader={() => {
                    return import("../DetailContent")
                  }}
                />
              </Route>
              {/* 旧租户进入的客户详情 */}
              <Route path="/customer/oldContent/:customerId">
                <Dynamic
                  loader={() => {
                    return import("../OldDetailContent")
                  }}
                />
              </Route>
              <Route path="/customer/search/:wxUserId">
                <Dynamic
                  loader={() => {
                    return import("../BindCustomer/SeachAndBind")
                  }}
                />
              </Route>
              <Route path="/customer/familyMember/:customerId">
                <Dynamic
                  loader={() => {
                    return import("../FamilyMember")
                  }}
                />
              </Route>
              <Route path="/customer/underwritingDetail">
                <Dynamic
                  loader={() => {
                    return import("../UnderWritingDetail")
                  }}
                />
              </Route>
              <Route path="/customer/tips">
                <Dynamic
                  loader={() => {
                    return import("../CustomerAuthTips/customerTips")
                  }}
                />
              </Route>
            </Route>
            <Route path="/scriptLibrary">
              <Route path="/scriptLibrary/content">
                <Dynamic
                  loader={() => {
                    return import("../ScriptLibrary")
                  }}
                />
              </Route>
              <Route path="/scriptLibrary/H5">
                <Dynamic
                  loader={() => {
                    return import("../ScriptLibrary/H5")
                  }}
                />
              </Route>
            </Route>
            <Route path="/product">
              <Route path="/product/list">
                <Dynamic
                  loader={() => {
                    return import("../Product")
                  }}
                />
              </Route>
            </Route>
            <Route path="/marketingMaterials">
              <Route path="/marketingMaterials/content">
                <Dynamic
                  loader={() => {
                    return import("../MarketingMaterials")
                  }}
                />
              </Route>
              <Route path="/marketingMaterials/h5">
                <Dynamic
                  loader={() => {
                    return import("../SourceMaterial/H5")
                  }}
                />
              </Route>
            </Route>
            <Route path="/group">
              <Route path="/group/detail/:chatId">
                <Dynamic
                  loader={() => {
                    return import("../GroupDetail")
                  }}
                />
              </Route>
            </Route>
          </Switch>
        )}
      </Loading>
    </div>
  )
}

export default connect(
  (state) => ({ ...state }),
  (dispatch) => {
    return {
      saveUser: (user: any) => {
        dispatch(saveUserInfo(user))
      },
    }
  },
)(withRouter(Home))
